module.exports = __webpack_public_path__ + "assets/TB-APP_Icon_Editing.svg";